import { action, orchestrator } from 'satcheljs';
import { selectSubcategory as selectSubcategoryMutator } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
import { OptionSubCategory } from 'owa-options-core';

const selectSubcategory = action('selectSubcategory', (subcategory: OptionSubCategory) => ({
    subcategory,
}));

export default selectSubcategory;

orchestrator(selectSubcategory, actionMessage => {
    const continueAfterConfirmCallback = () => {
        selectSubcategoryMutator(actionMessage.subcategory);
    };

    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
